export const yogaPages = [
  "yoga-for-pcos",
  "yoga-for-thyroid",
  "yoga-for-diabetes",
  "yoga-for-good-digestion",
  "yoga-for-high-blood-pressure",
  "yoga-for-back-pain",
  "yoga-for-strength-and-flexibility",
  "prenatal-yoga-and-breathwork",
  "postnatal-yoga-and-breathwork",
  "yoga-for-wellness",
  "yoga-for-weight-management",
  "yoga-for-hypertension",
  "chair-yoga-for-healthy-ageing",
  "yoga-for-healthy-ageing-chair-free-trial",
];

export const healthPages = [
  "health-for-pcos",
  "3-week-wellness-bootcamp",
  "4-week-nutrition-gut-health-program",
  "health-for-hypertension",
  "health-for-thyroid",
  "health-for-prenatal",
  "health-for-postnatal",
  "health-for-diabetes",
];

export const partnershipPages = [
  "yoga",
  "nutrition",
  "health",
  "dermatology",
  "airtel-yoga",
  "airtel-nutrition",
  "lwl-yoga",
  "lwl-nutrition",
  "dummy-yoga-test",
  "dummy-yoga-trial-test",
  "dummy-nutrition-test",
  "dummy-nutrition-trial-test",
  "airtel-yoga-trial",
  "icicibank-yoga",
  "icicibank-nutrition",
  "firstcry-yoga-trial",
  "firstcry-yoga",
  "firstcry-nutrition-trial",
  "firstcry-nutrition",
  "rblbank-yoga",
  "rblbank-nutrition",
  "idfcbank-yoga",
  "idfcbank-nutrition",
  "dbsbank-yoga",
  "dbsbank-nutrition",
  "superbottoms-yoga",
  "superbottoms-nutrition",
  "mybenefits-yoga",
  "mybenefits-yoga-trial",
  "mybenefits-nutrition",
  "mybenefits-nutrition-trial",
  "induslndbank-yoga",
  "induslndbank-nutrition",
  "dr-morepen",
  "inrd-wellness-yoga",
  "inrd-wellness-nutrition",
  "ek-wellness-yoga",
  "ek-wellness-nutrition",
  "rakbank-yoga",
  "rakbank-nutrition",
  "fuelyourtransformation-yoga",
  "beingnutritionist-yoga",
  "visa-yogapackage",
  "visa-nutritionpackage",
  "visa-yogatrial",
  "club-vistara-yoga",
  "club-vistara-nutrition",
  "jellybean-yoga-program",
  "jellybean-nutrition-program",
  "pazcare-yoga-program",
  "pazcare-nutrition-program",
  "indusind-yoga-program",
  "indusind-nutrition-program",
  "bain-yoga-program",
  "bain-nutrition-program",
  "smytten-yoga",
  "smytten-nutrition",
  "visa",
  "visa-nutrition",
  "mygate-partnership",
  "nobrokerhood-partnership",
  "bayzat-yoga",
  "bayzat-yoga-trial",
  "bayzat-nutrition",
  "bayzat-nutrition-trial",
  "wellness-yoga-deal",
  "wellness-nutrition-deal",
  "visa-nutrition-deal",
  "thriwe-yoga",
  "thriwe-yoga-trial",
  "fitze-yoga",
  "fitze-nutrition",
  "godigit-yoga",
  "godigit-nutrition",
  "partner-yoga",
];

export const corporatePartnerPages = [
  "corporate-partnership",
  "corporate-partnerships",
  "wellness-campaign",
  "allservices",
  "valeo-health",
  "redcliffe_yoga_trial",
];

export const healthPartnershipPages = [
  "redcliffe_health_programs",
  "tata-health-program",
];
export const wellnessPartnershipPrograms = [
  "ketto-wellness-program",
  "affordplan-yoga-wellness",
  "slice-yoga-wellness",
  "hdfc-wellness-program",
  "redcliffe_yoga_trial",
  "tata-wellness-program",
];

export const NUTRITION_ONBOARDING_PAGES = [
  "nutrition-user-onboarding-flow",
  "nutrition/"
]